require('styles/Form_layout.css');

import React from 'react';
import Reflux from 'reflux';
import FormItemContainer from './FormItemContainer';
import FormItemButton from './FormItemButton';
import FormItemUtil from '../utils/FormItemUtil';
import CmdTypeActions from '../actions/CmdTypeActions';

class FormItemButtonGroup extends FormItemContainer
{
	constructor(props) {
		super(props);
	}

	render()
	{
		let parent = this.props.xml;
		let children = parent.FormItem;
		let that = this;
		let list = children.map(function(item){
			return FormItemUtil.getFormItemInstance(that.props.menuItemId,that.props.formId,item,parent,that.props.forLookup);
  		 });
		
		var _style = Object.assign({},this.props.customStyle);
		if(!_style)_style = {};
		
		if(this.state.visible == false)
			if(this.state.hideInVisible == true) _style.display="none"; else _style.visibility="hidden";

		return (<div className={"GongqiFormItemButtonGroup"} id={this.props.xml.name} ref={node => this.containerComponent = node} style={_style}>{list}</div>);
	}
};

FormItemButtonGroup.defaultProps = {
};

export default FormItemButtonGroup;


// WEBPACK FOOTER //
// ./src/formItem/FormItemButtonGroup.js